import requester from '@/lib/axios';
import BookProgress, { BookProgressMarkAsRead } from '@/models/BookProgress';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

export interface ListBookProgressFilters extends BaseFilters {
  lessonProgressId?: number[];
  bookId?: number;
}

export async function getBookProgress(
  bookProgressId: number,
): Promise<BookProgress> {
  const { data } = await requester().get<BookProgress>(
    `book-progress/${bookProgressId}/`,
  );

  return data;
}

export async function listBookProgress(filters: ListBookProgressFilters = {}) {
  const { data } = await requester().get<JsonApiResponse<BookProgress>>(
    `book-progress/`,
    { params: filters },
  );

  return data;
}

export async function markBookProgressAsRead(bookProgressId: number) {
  const { data } = await requester().patch<BookProgressMarkAsRead>(
    `book-progress/${bookProgressId}/mark-as-read/`,
  );

  return data;
}
